module.exports = __webpack_public_path__ + "img/jawg-light.09002e31.jpg";